let load = require('./helpers/browser/esm-js-loader');
module.exports = Promise.all([load("5uoHm"), load("ipE7H")]).then(() => parcelRequire('bJETC'));